import { type ReactNode } from 'react'
import { FlowActionDropdown } from 'widgets/Flow/ui/FlowActionDropdown/FlowActionDropdown'

type IAddActionDropdownProps = {
  setOpen: (value: boolean) => void
  labelX: number
  labelY: number
  children: ReactNode
}

export const AddActionDropdown = ({
  setOpen,
  labelX,
  labelY,
  children,
}: IAddActionDropdownProps) => {
  return (
    <FlowActionDropdown
      setOpen={setOpen}
      transform={`translateX(-50%) translate(${labelX}px, ${labelY + 12}px)`}
      width={231}
    >
      {children}
    </FlowActionDropdown>
  )
}
